// Captures the user's role intent (renter vs owner) at the moment they
// click a role-revealing CTA. Persists across the OAuth redirect via
// localStorage so the post-auth router can land them on the right page
// without an extra wizard step.

const KEY = "mst_onboarding_intent_v1";

export type Intent = "renter" | "owner";

export const setIntent = (intent: Intent) => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY, intent);
  } catch {
    /* ignore */
  }
};

export const getIntent = (): Intent | null => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw === "renter" || raw === "owner") return raw;
    return null;
  } catch {
    return null;
  }
};

export const clearIntent = () => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
};
